import { GlobalSnackbarQueryMutationResolver } from '@deltek/specification-client/core/Configurations/GlobalSnackbar'
import { CurrentUserInfoQueryMutationResolver } from '@deltek/specification-client/core/GraphQL/Resolvers/currentUserInfo.resolvers'
import { BannerInfoResolver } from './bannerInfo.resolvers'
import { CategoriesResolver } from './category.resolvers'
import { AllProductsResolver } from './product.resolvers'
import { ProfessionalDisciplinesResolver } from './professionalDisciplines.resolvers'
import {
    GetProjectQueryResolver,
    GetProjectsQueryResolver,
    RecentlyViewedProjectsQueryResolver
} from './project.resolvers'
import { GetAllUsersQueryResolver } from './user.resolvers'

const resolvers = {
    Query: {
        ...AllProductsResolver,
        ...BannerInfoResolver,
        ...CategoriesResolver,
        ...GetProjectsQueryResolver,
        ...RecentlyViewedProjectsQueryResolver,
        ...ProfessionalDisciplinesResolver,
        ...GetProjectQueryResolver,
        ...GetAllUsersQueryResolver,
    },
    Mutation: {
        ...CurrentUserInfoQueryMutationResolver.Mutation,
        ...GlobalSnackbarQueryMutationResolver.Mutation,
    },
}

export default resolvers
